import { useState } from 'react';
// import { useAlert } from "react-alert";
import { yupFactory } from './CreateYupJSon';
import * as R from 'ramda';

export default function useValidation(init) {
  // const alert = useAlert();
  const [errors, setErrors] = useState({});
  const { data, key } = init;
  const [checker, checkVal] = yupFactory(data, key);

  async function checkFiled(name, value, isBack) {
    const message = await checker(name, value);
    setErrors((prev) => ({ ...prev, [name]: message }));
    return isBack ? message : null
  }

  async function checkValidation(values) {
    const [mess, allmess] = await checkVal(values);

    if (mess) {
      setErrors((prev) => ({ ...prev, ...allmess }));
      return false;
    }
    return true;
  }

  return { errors, checkFiled, checkValidation };
}

const mapper = (field) => {
  const [name, validationType, min= 1, max= 5] = field;

  if (validationType === 'time')
    return {
      name: `${name}`,
      validationType: 'string',
      validations: [
        {
          type: 'required',
          params: ['is required'],
        },
        {
          type: 'matches',
          // params: [/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "must be hh:mm"],
          params: [
            /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
            { message: ' must be HH:MM:SS', excludeEmptyString: false },
          ],
        },
      ],
    };

  if (validationType === 'array') {
    return {
      name: `${name}`,
      validationType: 'array',
      validations: [
        {
          type: 'required',
          params: ['is required'],
        },
        {
          type: 'min',
          params: [min,`${min} is required`],
        },
        {
          type: 'max',
          params: [max,`${max} is required`],
        },
        // {
        //   type: 'length',
        //   // params: [/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "must be hh:mm"],
        //   params: [size, 'is required'],
        // },
      ],
    };
  }

  return {
    name: `${name}`,
    validationType,
    validations: [
      {
        type: 'required',
        params: ['is required'],
      },
    ],
  };
};

export const mapFieldArrToObjSchema = R.map(mapper);
